export interface UsernameIdentity {
  username?: string | null;
  userName?: string | null;
  firstName?: string | null;
  displayName?: string | null;
  name?: string | null;
}

/**
 * Returns only the member's username. Personal-name fields remain in API
 * contracts for backward compatibility but are never identity labels on web.
 */
export function getUsernameDisplay(
  identity: UsernameIdentity | null | undefined,
  fallback = '',
): string {
  const candidates = [
    identity?.username,
    identity?.userName,
    fallback,
  ];

  for (const candidate of candidates) {
    if (typeof candidate === 'string' && candidate.trim()) {
      return candidate.trim();
    }
  }
  return '';
}
